angular.module('zc.zenclerkS')

  .component('zcsExcludeIpForm', {
    bindings: {
      project: '=',
      excludeIp: '=',
      currentIp: '=',
      onDestroy: '&',
    },
    templateUrl: '/templates/zenclerk_s/directives/exclude_ip_editor/exclude_ip_form.html',
    controllerAs: 'vm',
    controller: function($scope, ProjectExcludeIp) {
      const vm = this;

      vm.isDestroying = false;
      vm.isSaving = false;

      vm.saveExcludeIp = () => {
        vm.isSaving = true;

        if(vm.excludeIp.id) {
          ProjectExcludeIp.update({projectId: vm.project.id, id: vm.excludeIp.id}, {ip: vm.excludeIp.ip})
            .then(mergePageType)
            .catch(handleError);
        } else {
          ProjectExcludeIp.create({projectId: vm.project.id}, {ip: vm.excludeIp.ip})
            .then(mergePageType)
            .catch(handleError);
        }
      };

      vm.destroyExcludeIp = () => {
        if(!vm.excludeIp.id) {
          vm.onDestroy({excludeIp: vm.excludeIp});
        } else {
          vm.isDestroying = true;
          ProjectExcludeIp.delete(vm.project.id, vm.excludeIp.id)
            .then(res => {
              vm.onDestroy({excludeIp: vm.excludeIp});
              vm.isDestroying = false;
            })
            .catch(handleError);
        }
      };

      function mergePageType(res) {
        vm.excludeIps = _.merge(vm.excludeIps, res);
        vm.isSaving = false;
        $scope.excludeIpForm.$setPristine();
      }

      function handleError() {
        vm.isSaving = false;
        vm.isDestroying = false;
      }
    }
  });



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/exclude_ip_editor/exclude_ip_form.js